import { render, staticRenderFns } from "./status_selector.vue?vue&type=template&id=0d35d2a7&scoped=true"
import script from "./status_selector.vue?vue&type=script&lang=js"
export * from "./status_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d35d2a7",
  null
  
)

export default component.exports